module.exports = __webpack_public_path__ + "img/3.4.8ef4657e.png";